import type { HelpFile } from '../../types/help'
import { SchemaPolicyEditTestIds } from '../../../testids/SchemaPolicyEditTestIds'

export const schemaPolicyEditHelp: HelpFile = {
  docPage: '/docs/schema/policies',
  texts: {
    [SchemaPolicyEditTestIds.schemaPolicyEdit]:
      'Author or edit a schema policy — CEL expression evaluated against parties / identities, or a registered native-code producer.',
    [SchemaPolicyEditTestIds.inputName]:
      'Globally unique kebab-case slug — appears in the violation list and as the policy reference.',
    [SchemaPolicyEditTestIds.inputDescription]:
      'Short narrative explaining the invariant the policy enforces. Plain prose; supports no markup.',
    [SchemaPolicyEditTestIds.selectType]:
      'DSL evaluates the CEL expression at detection. NATIVE_CODE delegates to a registered Java producer (drops to raw SQL or other native logic).',
    [SchemaPolicyEditTestIds.inputExpression]:
      'CEL expression — supports party.* / identity.* roots, attribute references, `== null` / `!= null`, comparison + logical operators (`&&`, `||`, `!`).',
    [SchemaPolicyEditTestIds.inputConstraintCode]:
      'For NATIVE_CODE policies — the bean key matching @Component(producerCode = "…").',
    [SchemaPolicyEditTestIds.selectSeverity]:
      'Drives badge colour and ordering across violation lists. INFO / WARN / ERROR / CRITICAL.',
    [SchemaPolicyEditTestIds.inputMessageTemplate]:
      'Violation message rendered per row. {displayName}, {subjectId}, {constraintName} placeholders are interpolated.',
    [SchemaPolicyEditTestIds.btnSave]: 'Persist the policy. Newly created policies start disabled — enable explicitly from the policy detail page.',
    [SchemaPolicyEditTestIds.btnCancel]: 'Discard pending edits and return to the policies list.',
  },
}
